import React from "react";
import { OrderCostingVersion } from "../../../api/endpoints/Order";
import { formatBinaryCapacityUnit, formatDailyVolumeLimit } from "../../../utils/Format";

interface Props {
  costingVersion: OrderCostingVersion
}

const DailyVolumeExceededWarning = (props: Props) => {
  const { costingVersion } = props;

  const limit = formatDailyVolumeLimit(costingVersion.max_average_daily_volume);

  return (
    <div className="alert alert-danger">
      <p style={{ margin: 0 }}>
        Your estimated daily volume is over the maximum charge
        license limit of <strong>{limit} per day</strong>. Please, decrease the volume in order to submit the order.
      </p>
    </div>
  )
}

export default DailyVolumeExceededWarning;
